import getInstance from "../config/api";

export default class Billet {
  static async fetchBillets(params) {
    const instance = getInstance();
    const response = await instance.get("/payment", { params });
    return response.data;
  }

  static async fetchBilletGeneralInformation() {
    const instance = getInstance();
    const response = await instance.get("/payment/general-information");
    return response.data;
  }
  static async fetchBilletGenerationHistory(params) {
    const instance = getInstance();
    const response = await instance.get("/payment/generation-history", {
      params,
    });
    return response.data;
  }

  static async processPendingBillets(body) {
    const instance = getInstance();
    const response = await instance.post(`/payment`, body);
    return response.data;
  }

  static async deletePriorApproval(body) {
    const instance = getInstance();
    const response = await instance.delete(`/payment/delete-prior-approval`, {
      data: body,
    });
    return response.data;
  }

  static async createBilletFromInstallment(body) {
    const instance = getInstance();
    const response = await instance.post(
      `/payment/createBilletFromInstallment`,
      body
    );
    return response;
  }

  static async importCsvBillet(body) {
    const instance = getInstance();
    const { data } = await instance.post(`/payment/csv`, body);
    return data;
  }

  static async getContractInstallmentStatusJob() {
    const instance = getInstance();
    const response = await instance.get(
      "/payment/getContractInstallmentStatusJob"
    );
    return response.data;
  }
}
